import React, { useState, useEffect } from 'react';
import { useHistory, useLocation, Link } from 'react-router-dom';
import { useCookies } from 'react-cookie';
// import profile from "../../assets/profile.png";
import Profile from './Profile';
import CurrentSubscription from './CurrentSubscription';
import SubscriptionList from './SubscriptionList';
import SubscriptionHistory from './SubscriptionHistory';
import profileStore from '../../form/profile/profileStore';
import ProfileImage from '../../components/ProfileImage';
// import { getUser } from '../../api'
import { Layout, Row, Col } from 'antd';
// import { useCallback } from "react";
const { Content } = Layout;

const PROFIlE = 0;
const CURRENT_SCRIPTION = 1;
const SUBCRIPTION_HISTRORY = 2;
const SUBSCRIPTION_DETAIL = 3;

const SubscriptionParent = () => {
    const history = useHistory();
    const location = useLocation();
    const { state } = location;
    const [cookies, removeCookie] = useCookies(['SESSION']);
    const [current_page, setPageIndex] = useState(0);
    const { token_type, access_token } = cookies.SESSION;
    const token = `${token_type} ${access_token}`;

    useEffect(() => {
        let value = 0;
        if (location.hash === '#subscription-current') {
            value = 1;
        }
        if (location.hash === '#subscription') {
            value = 2;
        }
        if (location.hash === '#subscription-detail') {
            value = 3;
        }
        setPageIndex(value);
    }, [state, location.hash]);

    useEffect(() => {
        // profileStore.subscribe(setUser);
        profileStore.getUser(token);
    }, [token]);

    const renderPage = (index) => {
        switch (index) {
            case PROFIlE:
                return <Profile />;
            case CURRENT_SCRIPTION:
                return <SubscriptionList />;
            case SUBCRIPTION_HISTRORY:
                return <SubscriptionHistory />;
            case SUBSCRIPTION_DETAIL:
                return <CurrentSubscription />;
            default:
                return <SubscriptionList />;
        }
    };

    const logout = () => {
        removeCookie('SESSION', {
            path: '/',
        });
    };

    // watching on route change
    history.listen((location) => {
        let value = 0;
        if (location.hash === '#subscription-current') {
            value = 1;
        }
        if (location.hash === '#subscription') {
            value = 2;
        }
        if (location.hash === '#subscription-detail') {
            value = 3;
        }
        setPageIndex(value);
    });

    return (
        <Content className="profileContainer">
            <Row justify="center" style={{ height: '100%' }}>
                <Col
                    xs={{ span: 24 }}
                    sm={{ span: 24 }}
                    md={{ span: 6 }}
                    lg={{ span: 6 }}
                    xl={{ span: 6 }}
                    xxl={{ span: 6 }}
                    className="search-left"
                >
                    <ProfileImage allowedEdit={true} />
                    <br />
                    <Link
                        className="profileContainerMenu"
                        to={{
                            pathname: '/profile/detail',
                        }}
                    >
                        Profile
                    </Link>

                    <Link
                        className="profileContainerMenu"
                        to={{
                            pathname: '/subscriptions',
                            search: '?status=current',
                        }}
                    >
                        Current Subscritpion
                    </Link>

                    <Link
                        className="profileContainerMenu"
                        to={{
                            pathname: '/subscriptions',
                            search: '?status=history',
                        }}
                    >
                        Subscritpion History
                    </Link>

                    <Link
                        className="profileContainerMenu"
                        to={{
                            pathname: '/subscriptions',
                            search: '?status=change-password',
                        }}
                    >
                        Change Password
                    </Link>

                    <br />
                    <input className="profileLogout" type="submit" value="Logout" onClick={() => logout()} />
                </Col>
                <Col
                    xs={{ span: 24 }}
                    sm={{ span: 24 }}
                    md={{ span: 18 }}
                    lg={{ span: 18 }}
                    xl={{ span: 18 }}
                    xxl={{ span: 18 }}
                    className="search-right"
                >
                    {renderPage(current_page)}
                </Col>
                <div className="clearfix"></div>
            </Row>
        </Content>
    );
};

export default SubscriptionParent;
